import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { yesNoOptions } from '../../../../../../data/forms/generalDropdownOptions';

export default function WisconsinAdditionalInfoForm({ form, handleChange }) {
  return (
    <>
      <Grid size={6}>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Reported to Local Law Enforcement'}</InputLabel>
          <Select
            value={form.reportedToPolice}
            label={'Reported to Local Law Enforcement'}
            onChange={handleChange}
            name='reportedToPolice'
          >
            {yesNoOptions.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label='Investigating Officer'
          name='policeOfficerName'
          required={form.reportedToPolice === 'Yes'}
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
          value={form.policeOfficerName}
          onChange={handleChange}
        />
        <TextField
          label='Last Known Location of Listed Tickets'
          name='ticketLastLocation'
          required
          fullWidth
          value={form.ticketLastLocation}
          onChange={handleChange}
          sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
        />
      </Grid>
      <Grid size={6}>
        <TextField
          label='Police Agency'
          name='policeAgencyName'
          required={form.reportedToPolice === 'Yes'}
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
          value={form.policeAgencyName}
          onChange={handleChange}
        />
        <TextField
          label="Investigating Officer's Phone"
          name='policeOfficerPhone'
          required={form.reportedToPolice === 'Yes'}
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
          value={form.policeOfficerPhone}
          onChange={handleChange}
        />
        <TextField
          label='Suspected Status of Listed Tickets'
          name='ticketSuspectedStatus'
          required
          fullWidth
          value={form.ticketSuspectedStatus}
          onChange={handleChange}
          sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
        />
      </Grid>
    </>
  );
}
